import React, { useEffect } from "react";
import "./Modal.css";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    type?: "info" | "success" | "error";
    buttonText?: string;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, type = "info", buttonText = "OK" }) => {
    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.body.style.overflow = "";
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className={`modal-content modal-${type}`} onClick={(e) => e.stopPropagation()}>
                {title && <h3 className="modal-title">{title}</h3>}
                <div className="modal-body">{children}</div>
                {buttonText && (
                    <div className="modal-footer">
                        <button type="button" className="modal-btn" onClick={onClose}>
                            {buttonText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
